import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  Input,
  Renderer2,
  ViewChild
} from "@angular/core";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

const NRADIO_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => NRadioComponent),
  multi: true
};

@Component({
  selector: "n-radio",
  styleUrls: [
    "./n-radio.css"
  ],
  templateUrl: "./n-radio.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    NRADIO_VALUE_ACCESSOR
  ]
})
export class NRadioComponent implements ControlValueAccessor {

  @Input() value: any;

  @Input() text: string;

  @Input() description: string;

  @Input() name: string;

  @ViewChild("input", {read: ElementRef, static: true})
  input: ElementRef;

  private propagateChange: (_) => void;
  private propagateTouch: () => void;

  constructor(private renderer: Renderer2, private cd: ChangeDetectorRef) {

  }

  @Input()
  set disabled(val: boolean) { // deprecated
    this.setDisabledState(val);
  }

  @Input()
  set isDisabled(val: boolean) {
    this.setDisabledState(val);
  }

  onChange() {
    if (this.propagateChange) {
      this.propagateChange(this.value);
    }
  }

  onTouched() {
    if (this.propagateTouch) {
      this.propagateTouch();
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  writeValue(val: any): void {
    this.renderer.setProperty(this.input.nativeElement, "checked", val === this.value);
  }

  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.input.nativeElement, "disabled", isDisabled);
    this.cd.markForCheck();
  }

}
